import { useAccount } from '../../context/AccountContext';
import { useProduct } from '../../context/ProductContext';
import { useTinycmsSites } from './sites';

/**
 * What the selected site has beyond tinycms itself:
 *   Prism AI the atomizer product (comes with Pro). "held" also covers
 *            switched off (it can be switched back on).
 *   Reach    the reach product (comes with Pro).
 * fullAnalytics: Website → Analytics, the full page. Business and Pro, and a
 *   site with no plan; Today's website panel is on every plan. The server
 *   enforces this (fullAnalyticsAllowed in apiserver services/plans.js).
 * isOwner: the person is an admin of this site (they can change its plan).
 */
export function useAddons() {
  const { selectedAccount } = useAccount();
  const { entitled } = useProduct();
  const { sites } = useTinycmsSites();
  const products = selectedAccount?.products;
  const atomizeOn =
    products == null
      ? entitled.includes('atomizer')
      : products.some((p) => p.product === 'atomizer' && p.status === 'active');
  const atomizeHeld = products == null ? atomizeOn : products.some((p) => p.product === 'atomizer');
  // The same switch sets this. A site left off in the database stays off
  // until an owner turns Prism AI on.
  const readsOn = atomizeOn && selectedAccount?.autoAtomizeEnabled !== false;
  const here = sites.find((s) => s.accountId === selectedAccount?.id);
  const plan = products?.find((p) => p.product === 'tinycms')?.plan;
  return {
    atomizeOn,
    atomizeHeld,
    readsOn,
    reachOn: entitled.includes('reach'),
    fullAnalytics: plan !== 'free' && plan !== 'personal',
    isOwner: here ? here.role === 'admin' : true,
    ownerEmail: here?.ownerEmail || null,
  };
}
